import React from "react";

const StopIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            viewBox="0 0 1024 1024"
            width="1em"
            height="1em"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M514.4 36C250.8 36 36 250.8 36 514.4s214.8 478.4 478.4 478.4 478.4-214.8 478.4-478.4S777.6 36 514.4 36L514.4 36zM514.4 932.8c-231.2 0-418.4-188-418.4-418.4 0-231.2 188-418.4 418.4-418.4 231.2 0 418.4 188 418.4 418.4C932.8 745.2 745.2 932.8 514.4 932.8L514.4 932.8z" />
            <path d="M620 684l-218.8 0c-33.2 0-60-27.2-60-60l0-218.8c0-33.2 27.2-60 60-60L620 345.2c33.2 0 60 27.2 60 60L680 624C680 657.2 653.2 684 620 684z" />
        </svg>
    );
};

export default StopIcon;